export default __webpack_public_path__ + "static/suisse-a50708c6e32c0849e9f277fcb06acc25.otf";